import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import Util from "ips/ac/util/Util";

export default class ODataService {
  public static submitBatch(updateGroup?:string): Promise<void> {
    return new Promise(async (resolve, reject) => {

      const model:ODataModel = Util.getODataModel() as ODataModel;
      if(!updateGroup){
        updateGroup = model.getUpdateGroupId();
      }
      try{
        await model.submitBatch(updateGroup);
        if(!model.hasPendingChanges(updateGroup)){
          resolve();
        } else {
          reject(new Error("Pending changes in batch group: " + updateGroup));
        }
      }catch(e){
        reject(e);
      }

    });
  }
}